export default __webpack_public_path__ + "static/media/eye-2.1933d07f.svg";